module.exports = __webpack_public_path__ + "static/flower.e9510833.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/flower.png
// module id = 1288
// module chunks = 168707334958949